module.exports = __webpack_public_path__ + "media/application/images/svgs/demsoc/cross-972c2205991fdc71a0e7c85b292b3a1b.svg";